import React, { Fragment, useEffect, lazy, Suspense } from "react";

import { testimonialData } from "./HomeData";
const HomeReadyForm = lazy(() => import("./HomeReadyForm"));
const HomeCertifid = lazy(() => import("./HomeCertifid"));
const ReviesAll = lazy(() => import("../ReviesAll"));
const HomeNewBanner = lazy(() => import("./HomeNewBanner"));
const HomePartner = lazy(() => import("./HomePartner"));
const HomeServices = lazy(() => import("./HomeServices"));
const HomeAboutUs = lazy(() => import("./HomeAboutUs"));
const HomeScoreCheck = lazy(() => import("./HomeScoreCheck"));
const HistoricalSEO = lazy(() => import("./HistoricalSEO"));
const HomeTimeLineAnimate = lazy(() => import("./HomeTimeLineAnimate"));
const WhoWeCaseStudy = lazy(() =>
  import("../WhoWeAreComponents/WhoWeCaseStudy")
);
const CityAround = lazy(() => import("./CityAround"));

const Home = () => {
  useEffect(() => {
    document.body.classList.add("home-layout");
    return () => {
      document.body.classList.remove("home-layout", "inner-page-layout");
    };
  }, []);

  return (
    <Fragment>


      <Suspense fallback={<div>Loading...</div>}>
        <HomeNewBanner />

        <HomePartner />
        <HomeAboutUs />
        <HomeServices />
        <HistoricalSEO />
        <HomeTimeLineAnimate />
        <WhoWeCaseStudy
          addList="case_study_sec text-center home_case_studies_section"
          addid="home_studies_slider"
        />
        <HomeScoreCheck />
        <ReviesAll
          mainclassName="home_restimonials"
          heading="Testimonials"
          SubHeading="What Our Client Say"
          details={testimonialData}
        />
        <HomeReadyForm />
        <HomeCertifid />
        <CityAround />
      </Suspense>
    </Fragment>
  );
};

export default Home;
